import React, { useEffect, useState } from 'react';
import styles from '../allEnquiresTab/specificationsTab.module.css';
import styless from '../schedulePOComps/orderdetails.module.css';
import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import OrderTable from './OrderTable';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCartOrderdetailsThunk, getPoOrderdetailsThunk } from '../../../../Website/redux/poorderSlice';
import { formateDate } from '../../../../Website/utils/utils';
import PoOrderTable from './PoOrderTable';
import OrderProgress from './OrderProgress';
import { formatINR } from '../../../../Website/utils/gstTotals';

const StyledGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
}));



const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '014px',
    color: '#667085',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    borderRadius: "4px",
    height: "40px",
    fontFamily: `'Public Sans', sans-serif`,
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

const Orderscomp = ({ tab }) => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const { orders, orderDetails, loading } = useSelector(state => state.poorder)
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate()





    useEffect(() => {
        if (tab == "0") {
            dispatch(getCartOrderdetailsThunk(id))
        } else {
            dispatch(getPoOrderdetailsThunk(id))
        }
    }, [])

    console.log(orderDetails);


    const calculateSubtotal = (partList = []) => {
        return partList.reduce((sum, item) => {
            return sum + (item.quotePrice || 0) * (item.quantity || 0);
        }, 0);
    };

    const calculateTotalGst = (partList = []) => {
        return partList.reduce((sum, item) => {
            const lineTotal = (item.quotePrice || 0) * (item.quantity || 0);
            const gstAmount = lineTotal * ((item.gst || 0) / 100);
            return sum + gstAmount;
        }, 0);
    };

    const calculateTotalAmount = (partList = []) => {
        const subtotal = calculateSubtotal(partList);
        const totalGst = calculateTotalGst(partList);

        return subtotal + totalGst;
    };

    // Money is shown to the paisa (no long decimals like 1188.0000000000002)
    const round2 = (value) => Math.round((Number(value) || 0) * 100) / 100;
    const money = (value) => formatINR(round2(value));

    // Cart orders: GST is a flat 18% added on top of the subtotal
    const CART_GST_RATE = 18;
    const cartSubtotal = round2(orderDetails?.priceBreakup?.subTotal);
    const cartTax = round2(cartSubtotal * CART_GST_RATE / 100);

    // Purchase orders: GST can differ per item; show the rate when every item has the same one
    const poRates = [...new Set((orderDetails?.partList || []).map((item) => Number(item.gst) || 0))];
    const poTaxLabel = poRates.length === 1 ? `Tax (${poRates[0]}%)` : 'Tax (GST)';

    const summary = tab == "0"
        ? { subtotal: cartSubtotal, taxLabel: `Tax (${CART_GST_RATE}%)`, tax: cartTax, total: cartSubtotal + cartTax }
        : {
            subtotal: calculateSubtotal(orderDetails?.partList),
            taxLabel: poTaxLabel,
            tax: round2(calculateTotalGst(orderDetails?.partList)),
            total: round2(calculateSubtotal(orderDetails?.partList)) + round2(calculateTotalGst(orderDetails?.partList)),
        };


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 10, width: '100%' }}>
                <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
            </div>
        )
    }
    return (
        <>
            <div className={styles.profilebodyContainer}>
                <div className={styles.profileheader}>
                    <Box display="flex" alignItems="center" >
                        <h2>Order Details</h2>
                        <Typography style={{ margin: '6px' }}>•</Typography>
                        <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>

                            {formateDate(orderDetails?.createdAt)}
                        </Typography>
                        <Typography style={{ margin: '6px' }}>•</Typography>
                        <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#E9BD21' }}>
                            {orderDetails?.products?.length} Products
                        </Typography>
                    </Box>
                    <button className={styles.editbtn} onClick={() => navigate(-1)}>Back to List</button>
                </div>


                <div className={styless.ordetailsbody}>
                    <div className={styless.ordetailsaddress}>
                        {/*  Billing and Shipping Addresses  */}
                        <div className={styless.address_container}>
                            <div className={styless.address_box}>
                                <div className={styless.h3}>Shipping Address</div>
                                <div className={styless.address_deets}>
                                    {tab == "0" ?
                                        <>
                                            <span>{orderDetails?.address?.factoryUnits}</span>
                                            <p>{orderDetails?.address?.streetAddress}. {orderDetails?.address?.state}, {orderDetails?.address?.country} {orderDetails?.address?.zipCode}</p>
                                        </>
                                        :
                                        <>
                                            <span>{orderDetails?.shippingAddress?.factoryUnits}</span>
                                            <p>{orderDetails?.shippingAddress?.streetAddress}. {orderDetails?.shippingAddress?.state}, {orderDetails?.shippingAddress?.country} {orderDetails?.shippingAddress?.zipCode}</p>
                                        </>
                                    }
                                    <p>Email: <br /><span>{orderDetails?.userId?.email}</span></p>
                                    <p>Phone: <br /><span>{orderDetails?.userId?.phone}</span></p>
                                </div>
                            </div>
                        </div>
                        <div className={styless.order_summary}>
                            <div className={styless.order_head}>
                                <div className={styless.h3}>Order ID: <br /><span>#{orderDetails?._id}</span> </div>
                                <Box display="flex" alignItems="center">
                                    <svg width="2" height="40" viewBox="0 0 2 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 0L1 40" stroke="#E6E6E6" />
                                    </svg>
                                </Box>
                            </div>
                            <div className={styless.order_deets}>
                                <p style={{ borderBottom: "1px solid #E6E6E6" }}>Subtotal: <span>{money(summary.subtotal)}</span></p>
                                <p style={{ borderBottom: "1px solid #E6E6E6" }}>{summary.taxLabel}: <span>{money(summary.tax)}</span></p>
                                <p style={{ borderBottom: "1px solid #E6E6E6" }}>Shipping: <span>Free</span></p>
                                <p>Total: <span>{money(summary.total)}</span></p>
                            </div>
                        </div>
                    </div>

                </div>


                <OrderProgress status={orderDetails?.status} type="order" />
                {
                    tab == "0" ?
                        <OrderTable data={orderDetails?.products} />
                        :
                        <PoOrderTable data={orderDetails?.partList} />
                }
            </div>
        </>
    );
};

export default Orderscomp;
